import React, {Component} from 'react';
import _ from "lodash";
import {langs} from "./config/localization";
import moment from 'moment';

/*function for render redux form field*/
export const renderField = (field) => {
    const {meta: {touched, error}} = field; //es6 syntex
    const className = `form-group ${touched && error ? 'has-danger':'has-success'}`;
    let fieldType = 'input';
    let requiredSpan =  "";
    let customMaxLength = 45;
    if(field.maxLength){
        customMaxLength = field.maxLength;
    }
    //Check and set as field input type
    if((field.input.name == 'Password' || field.input.name == 'password_confirmation') ){
        if(Object.getOwnPropertyNames(field.user_id).length > 0)
            return (<div></div>);
        fieldType = 'password';
    }
    if(field.input.name == 'Id'){
        fieldType = 'hidden';
    }
    if(field.input.name == 'Gender'){
        fieldType = 'radio';
    }



    if(field.input.name == 'Email' && field.input.value && Object.getOwnPropertyNames(field.user_id).length > 0){
        return (

            <div className={className}>
                <label className="form-label">{field.label}</label>
                <div>{field.input.value}</div>
            </div>
        )

    }

    if(field.isRequired == 'true'){
        return (

            <div className={className}>
                <label className="form-label">{field.label} {requiredSpan}</label><span className="text-danger">*</span>
                <field.type className="form-control" maxLength={customMaxLength} type={fieldType} {...field.input} />
                <div className="text-help">
                    {touched ? error : ''}
                </div>
            </div>
        )
    }else{

        return (

            <div className={className}>
                <label className="form-label">{field.label} {requiredSpan}</label>
                <field.type className="form-control " maxLength={customMaxLength} type={fieldType} {...field.input} />
                <div className="text-help">
                    {touched ? error : ''}
                </div>
            </div>
        )
    }
}


export const renderSelectField = (field) => {

    const {meta: {touched, error}} = field; //es6 syntex
    const className = `form-group ${touched && error ? 'has-danger':'has-success'}`;
    return (
        <div className={className}>
            <select className="form-control" {...field.input} >
                <option value="">Select</option>
                { field.children } </select>
            <div className="text-help">
                {touched ? error : ''}
            </div>
        </div>
    )
}

export function renderTextArea(field){
    const { meta : { touched, error} } = field;
    const className = `form-group ${touched && error ? 'has-danger' : 'has-success'}`;
    if(field.isRequired == 'true'){
        return(
            <div className={className}>
                <label>{field.label }</label><span className='text-danger'>*</span>
                <textarea maxLength={201} className="form-control" {...field.input}></textarea>
                <div className="text-help">{(touched) ? error: ''}</div>
            </div>
        );
    }else{
        return(
            <div className={className}>
                <label>{field.label }</label>
                <textarea maxLength={201} className="form-control" {...field.input}></textarea>
                <div className="text-help">{(touched) ? error: ''}</div>
            </div>
        );
    }
}

/**
 * Strip html tags
 * @param text
 */
export function stripHtml(text) {
    return text.replace(/<[^>]+>/g, '');
}

/**
 * Format video duration in human readable form
 * @param videoDuration
 */
export function formatVideoDuration(videoDuration) {
    const splittedDuration = videoDuration.split(':');

    let formattedDuration   = [];
    let counter             = 1;

    _.map(splittedDuration, duration => {
        if(counter === 1 && duration > 0) {
            formattedDuration.push(`${Math.ceil(duration)}h`);
        } else if(counter === 2 && (duration > 0)) {
            formattedDuration.push(`${Math.ceil(duration)}min`);
        } else if(counter === 3 && (duration > 0)) {
            formattedDuration.push(`${Math.ceil(duration)}s`);
        }

        counter++;
    });

    return formattedDuration.join(' ');
}

/**
 * Pad the number with leading zeros
 * @param value
 * @param size
 * @returns {*}
 */
export function numberPadding(value, size) {
    let val = value.toString();

    while (val.length < size) {
        val = "0" + val;
    }

    return val;
}

/**
 * Make year range
 * @param startYear
 * @param totalYears
 * @returns {{}}
 */
export function makeNumberRange(start, total) {
    let range = [];
    const last = start + total;

    for(start; start <= last; start++) {
        range = [...range, start];
    }

    return range;
}

/**
 * Make month year range for month picker
 * @param startMonth
 * @param startYear
 * @param endMonth
 * @param endYear
 * @returns {{min: {year: number, month: number}, max: {year: number, month: number}}}
 */
export function makeMonthYearRangeForMonthPicker(startMonth, startYear, endMonth, endYear) {
    const range = {
        min: {year: startYear, month: startMonth},
        max: {year: endYear, month: endMonth}
    };

    return range;
}

/**
 * Get the time difference in time ago format
 * @param currentTime
 * @param previousTime
 * @returns {string}
 */
export function timeAgo(currentTime, previousTime) {
    const msPerMinute   = 60 * 1000;
    const msPerHour     = msPerMinute * 60;
    const msPerDay      = msPerHour * 24;
    const msPerMonth    = msPerDay * 30;
    const msPerYear     = msPerDay * 365;
    const elapsed       = currentTime - previousTime;

    if (elapsed < msPerMinute) {
        //return Math.round(elapsed/1000) + ' seconds ago';
        return langs.just_now;
    } else if (elapsed < msPerHour) {
        return Math.round(elapsed/msPerMinute) + ` ${langs.minute}`;
    } else if (elapsed < msPerDay) {
        return Math.round(elapsed/msPerHour ) + ` ${langs.hour}`;
    } else if (elapsed < msPerMonth) {
        return Math.round(elapsed/msPerDay) + ` ${langs.day}`;
    } else if (elapsed < msPerYear) {
        return Math.round(elapsed/msPerMonth) + ` ${langs.month}`;
    } else {
        return Math.round(elapsed/msPerYear ) + ` ${langs.year}`;
    }
}

/**
 * Detect the url in string and replace it with anchor tag
 * @param text
 */
export function urlify(text) {
    const stripedHtml = stripHtml(text);
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return stripedHtml.replace(urlRegex, function(url) {
        return '<a target="_blank" href="' + url + '">' + url + '</a>';
    });
}

/**
 * Truncate text and add ellipsis
 * @param text
 * @returns {*}
 */
export function truncateText(text, limit) {
    if (text.length > limit) {
        return text.substring(0, limit) + '...';
    }

    return text;
}

/**
 * Convert date
 * @param date
 * @returns {string}
 */
export function convertDate(date) {
    return moment(date).format("DD-MM-YYYY hh:mm A");
}

/**
 * Check if user agent is mobile or not
 * @returns {boolean}
 */
export function isUserAgentMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * function for show focus on errors
 * @param errors
 */
export const focusOnError = (errors) => {
    const errorEl = document.querySelector(
        Object.keys(errors).map(fieldName => {
            return `[name="${fieldName}"]`
        }).join(',')
    );

    if (errorEl && errorEl.focus) {
        errorEl.focus();
    } else if(errors.profile != undefined || errors.nameWebsites != undefined) {
        if(window.location.hash == '#yourStory') {
            window.location.href = window.location.href;
        } else {
            window.location.hash = '#yourStory';
        }
    }
}

export const testTags = () => {
    return  [
        {
            "tagId": "5b6912efb48a5d5f1054b366",
            "tagName": "ocean",
            "tagCount": 25
        },
        {
            "tagId": "5b6912efb48a5d5f1054b35e",
            "tagName": "plastic",
            "tagCount": 24
        },
        {
            "tagId": "5b6912efb48a5d5f1054b365",
            "tagName": "food",
            "tagCount": 15
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3ab",
            "tagName": "recycling",
            "tagCount": 15
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3b7",
            "tagName": "upcycling",
            "tagCount": 14
        },
        {
            "tagId": "5b6912efb48a5d5f1054b35f",
            "tagName": "water",
            "tagCount": 13
        },
        {
            "tagId": "5b6912efb48a5d5f1054b35d",
            "tagName": "blockchain",
            "tagCount": 11
        },
        {
            "tagId": "5b6912efb48a5d5f1054b367",
            "tagName": "media",
            "tagCount": 11
        },
        {
            "tagId": "5b6912efb48a5d5f1054b36d",
            "tagName": "money",
            "tagCount": 11
        },
        {
            "tagId": "5b6912efb48a5d5f1054b361",
            "tagName": "health",
            "tagCount": 10
        },
        {
            "tagId": "5b6912efb48a5d5f1054b364",
            "tagName": "innovation",
            "tagCount": 10
        },
        {
            "tagId": "5b6912efb48a5d5f1054b370",
            "tagName": "biodiversity",
            "tagCount": 9
        },
        {
            "tagId": "5b6912efb48a5d5f1054b378",
            "tagName": "diet",
            "tagCount": 8
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3cf",
            "tagName": "nutrition",
            "tagCount": 8
        },
        {
            "tagId": "5b6912efb48a5d5f1054b36f",
            "tagName": "learning",
            "tagCount": 7
        },
        {
            "tagId": "5b6912efb48a5d5f1054b373",
            "tagName": "economy",
            "tagCount": 7
        },
        {
            "tagId": "5b6912efb48a5d5f1054b393",
            "tagName": "threatened",
            "tagCount": 7
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3b1",
            "tagName": "nature",
            "tagCount": 7
        },
        {
            "tagId": "5b6912efb48a5d5f1054b35c",
            "tagName": "PlasticRoads",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b376",
            "tagName": "India",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b382",
            "tagName": "footprint",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b383",
            "tagName": "China",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b397",
            "tagName": "Netherlands",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3a8",
            "tagName": "marine",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3b6",
            "tagName": "inflammation",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3ce",
            "tagName": "pollutants",
            "tagCount": 6
        },
        {
            "tagId": "5b6912efb48a5d5f1054b359",
            "tagName": "birds",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b35b",
            "tagName": "3Dprinting",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b36e",
            "tagName": "MOOCs",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b37e",
            "tagName": "CIQ",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3bd",
            "tagName": "Scotland",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3cc",
            "tagName": "Texas",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b3dd",
            "tagName": "UK",
            "tagCount": 5
        },
        {
            "tagId": "5b6912efb48a5d5f1054b362",
            "tagName": "unicorn",
            "tagCount": 4
        },
        {
            "tagId": "5b6912efb48a5d5f1054b363",
            "tagName": "earthDECKS",
            "tagCount": 3
        }
    ];
}

/**
 * Format time
 * @param timeInSeconds
 * @returns {string}
 */
export const formatTime = (timeInSeconds) => {
    const completeTime = getTimeParts(timeInSeconds);
    let hours = completeTime[0];
    let minutes = completeTime[1];
    let seconds = completeTime[2];

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    return hours+':'+minutes+':'+seconds;
};

/**
 * Get time parts
 * @param timeInSeconds
 * @returns {Array}
 */
export const getTimeParts = (timeInSeconds) => {
    let sec_num = parseInt(timeInSeconds, 10); // don't forget the second param
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    let completeTime = [];

    completeTime.push(hours);
    completeTime.push(minutes);
    completeTime.push(seconds);

    return completeTime;
}



// WEBPACK FOOTER //
// ./utils.js